import { useState } from 'react'
import {
  isContactPickerSupported,
  pickContacts,
  whatsappInviteUrl,
  type PickedContact,
} from '../lib/contacts'
import { WhatsAppIcon } from './WhatsAppIcon'

type Props = {
  message: string
  onError: (msg: string) => void
}

export function ContactInviteSection({ message, onError }: Props) {
  const supported = isContactPickerSupported()
  const [picked, setPicked] = useState<PickedContact[]>([])
  const [busy, setBusy] = useState(false)

  async function abrirAgenda() {
    setBusy(true)
    try {
      const rows = await pickContacts(true)
      setPicked(rows)
      if (rows.length === 0) {
        onError('Nenhum contato com telefone foi selecionado.')
      }
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Não foi possível abrir a agenda.'
      if (!/abort|cancel|NotAllowedError/i.test(msg)) {
        onError(msg)
      }
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="bp-card">
      <p className="bp-card__eyebrow">Agenda do celular</p>
      <p className="bp-muted" style={{ marginTop: 0 }}>
        Escolha contatos no aparelho e envie o convite no WhatsApp. Nada da agenda é salvo no
        servidor.
      </p>

      {supported ? (
        <button type="button" className="bp-btn bp-btn--primary" disabled={busy} onClick={() => void abrirAgenda()}>
          {busy ? 'Abrindo agenda…' : 'Escolher da agenda'}
        </button>
      ) : (
        <p className="bp-muted" style={{ marginBottom: 0 }}>
          Disponível no Chrome/Android com HTTPS. Neste navegador use Copiar ou WhatsApp acima.
        </p>
      )}

      {picked.length > 0 ? (
        <ul className="bp-people" style={{ marginTop: '0.85rem' }}>
          {picked.map((c) => (
            <li key={`${c.digits}-${c.name}`}>
              <div className="bp-person" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '0.4rem' }}>
                <span>
                  <strong>{c.name}</strong>
                  <span className="bp-muted" style={{ display: 'block' }}>
                    {c.tel}
                  </span>
                </span>
                <a
                  className="bp-btn bp-btn--wa"
                  href={whatsappInviteUrl(c.digits, message)}
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon />
                  Convidar no WhatsApp
                </a>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  )
}
